import React from 'react';
import Login from '../../Component/loginform/login';
import Layout from '../../reusables/layout/layout';
import BeceLogin from '../../Component/loginform/BeceLogin';


const PaymentLoginCas = () => {



    return (
        <>
            {/* <div>
                <Layout>
                    <Login
                        examType={'CAS EXAMINATION'}
                        url={"/user/login/03"}
                        navigateTo={'/requisition/junior'} homeLink={"https://cas.examsboard.lagosstate.gov.ng/"} />
                        
                </Layou
                t>
            </div> */}
                <div>
        <Layout>
          <BeceLogin
            examType={"CAS EXAMINATION"}
            url={"/user/schoolUser-login/03"}
            navigateTo={"/requisition/junior"}
            homeLink={"https://cas.examsboard.lagosstate.gov.ng/"} 
          />
        </Layout>
      </div>

        </>
    );
};

export default PaymentLoginCas;